// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductListStatusB_ProductList__Ab3eU","DutyFreeModal":"ProductListStatusB_DutyFreeModal__qOBKa"};